/**
 * Enum for mutex lock names used in the application.
 */
export enum MutexLockNames {
  SYNCHRONIZED_TOKEN_REFRESH = 'synchronized_token_refresh',
}
